import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import PublicImage from "@/models/PublicImage/PublicImage";
import WebsiteBrandPillar from "@/models/WebsiteBrandPillar/WebsiteBrandPillar";
import WebsitePage from "@/models/WebsitePage/WebsitePage";

export default class WebsiteFeaturedArticle extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-featured-article';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteFeaturedArticles';

    static fields() {
        return {
            id:this.number(null).nullable(),
            article_preview_image_id: this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            brand_pillar_id: this.number(null).nullable(),
            website_page_id: this.number(null).nullable(),
            articlePreviewImage: this.belongsTo(PublicImage, 'article_preview_image_id'),
            brandPillar: this.belongsTo(WebsiteBrandPillar, 'brand_pillar_id'),
            subBrandPillars: this.attr([]),
            user: this.belongsTo(User, 'user_id'),
            websitePage: this.belongsTo(WebsitePage, 'website_page_id'),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    Url() {
        const websitePage = this.WebsitePage();

        if (websitePage && websitePage.url) {
            return '/website-pages/' + websitePage.url;
        }

        // Fallback when no related page or slug is available
        return '/website-pages';
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    WebsiteUrl() {
        return window.config.WEBSITE_URL + this.Url();
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    User() {
        return this.getRelated('user');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteBrandPillar() {
        return this.getRelated('brandPillar');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage() {
        return this.getRelated('articlePreviewImage');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsitePage() {
        return this.getRelated('websitePage');
    }

    /**
     * @returns {*}
     * @constructor
     */
    SubBrandPillars() {
        return this.getRelated('subBrandPillars');
    }
}
